import { Injectable } from '@angular/core';
import { Country_Context_Url, CountryContextUrl, Country_Context_Phone, CountryContextPhone } from './country-context-url.service';

@Injectable({
  providedIn: 'root'
})

export class GetFordExperienceUrlService {
  getUrl(country: string, context: keyof CountryContextUrl): string | undefined {
    return Country_Context_Url[country]?.[context];
  }

  getPhone(country: string, context: keyof CountryContextPhone): string | undefined {
    return Country_Context_Phone[country]?.[context];
  }
}